import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { closeMsg, t } from '../../common/i18n/index.js';

export const DeviceSelectionDisclaimerCoCo = () => (
  <CL.Disclaimer
    className="of-device-selection-disclaimer-coco"
    disclaimerType="info"
    showCloseButton
    i18n_disclaimer_closeButtonTitle={t.WOYD(closeMsg)}
    ariaRole="status"
    ariaLive="polite"
    visible
  >
    <h5 className={dsClass.MARGIN_0}>
      {t.EUOO('With a device list, you can define the device selection available for employees’ orders.')}
    </h5>
    <p className={dsClass.MARGIN_TOP_1}>
      {t.FHGI(
        'A company can have multiple device lists with different settings and device selections. Note that products from different device lists cannot be ordered within a single order. For this reason, for example, a phone device selection should also include any related phone accessories so that they can be ordered together in the same order.'
      )}
    </p>
    <h5 className={`${dsClass.MARGIN_TOP_3} ${dsClass.MARGIN_BOTTOM_0}`}>
      {t.H7ZS('A device list is linked to a device selection.')}
    </h5>
    <p className={`${dsClass.MARGIN_TOP_1} ${dsClass.MARGIN_BOTTOM_0}`}>
      {t.CAW1(
        'When needed, multiple device lists can use the same device selection. The device list with its settings is company‑specific, but the device selection can be shared with other companies within the organization structure.'
      )}
    </p>
  </CL.Disclaimer>
);
